import {
	Box,
	FormControl,
	Grid,
	IconButton,
	InputLabel,
	MenuItem,
	Select,
} from "@mui/material";
import { useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Context } from "./Context";
import DeleteIcon from "@mui/icons-material/Delete";

const Api = ({ category }) => {
	const { t } = useTranslation();
	const { apis, setApis } = useContext(Context);

	useEffect(() => {
		console.log("apis", apis);
		console.log("category", category);
	}, [apis, category]);

	return (
		<>
			{apis
				.filter((api) => api.category === category.name)
				.map((api, index) => (
					<Grid key={index} container spacing={2} sx={{ mt: 1.5 }}>
						<Grid item xs={12} width={"100%"}>
							<Box
								sx={{
									display: "flex",
									gap: 1,
									justifyContent: "center",
									alignContent: "center",
								}}
							>
								<IconButton
									color="error"
									onClick={() => {
										setApis(
											apis.filter(
												(a) =>
													!(
														a.category ===
															category.name &&
														a.id === api.id
													)
											)
										);
									}}
								>
									<DeleteIcon />
								</IconButton>

								<FormControl fullWidth size="small">
									<InputLabel id="l-api">
										{t(
											"custom_reports.reports.table.dialog.edit_api.api"
										)}
									</InputLabel>
									<Select
										labelId="l-api"
										id="api"
										value={api.value}
										label={t(
											"custom_reports.reports.table.dialog.edit_api.api"
										)}
										onChange={(e) => {
											console.log(
												"e.target.value",
												e.target.value
											);
											const exist = apis.find(
												(a) =>
													a.category ===
														category.name &&
													a.id === api.id
											);
											const blank = apis.find(
												(api) =>
													api.category ===
														category.name &&
													api.value === ""
											);

											if (exist) {
												setApis((prev) => {
													return prev.map((a) => {
														if (a.id === api.id) {
															return {
																id: a.id,
																category:
																	category.name,
																value: e.target
																	.value,
															};
														}

														return a;
													});
												});
											}

											if (blank) {
												setApis((prev) => {
													return prev.map((a) => {
														if (a.value === "") {
															return {
																id: a.id,
																category:
																	category.name,
																value: e.target
																	.value,
															};
														}

														return a;
													});
												});
											}
										}}
									>
										{category.endpoints.map((endpoint) => (
											<MenuItem
												key={endpoint.id}
												value={endpoint.id}
											>
												{endpoint.name}
											</MenuItem>
										))}
									</Select>
								</FormControl>
							</Box>
						</Grid>
					</Grid>
				))}
		</>
	);
};

export { Api };
